import { render } from "./PGALibs.vue?vue&type=template&id=1d71973e&ts=true"
import script from "./PGALibs.vue?vue&type=script&lang=ts"
export * from "./PGALibs.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__